import { Modal } from "antd";
import React, { useState } from "react";
import { promoContent } from "./promoData";
import PromoItem from "./promoItem";
import { useTranslation } from "react-i18next";

const PromoContent = ({ promoTab }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({});

  const handleModalPopUp = (content) => {
    setModalContent(content);
    setShowModal(true);
  };

  const handleCancel = () => {
    setShowModal(false);
  };

  const translateContent = (content) => {
    if (typeof content === "string") {
      return t(content);
    } else {
      return content;
    }
  };

  return (
    <>
      {promoContent
        .filter((item) => item.category.includes(promoTab)) // ✅ Filters by selected tab
        .map((item, index) => (
          <PromoItem
            key={index}
            img={item.img}
            title1={t(item.title1)}
            title2={t(item.title2)}
            onClick={() => handleModalPopUp(item)}
          />
        ))}

      <Modal
        title={t(modalContent.title1)}
        centered
        open={showModal}
        onCancel={handleCancel}
        footer={null}
      >
        <img src={modalContent.img} alt={t(modalContent.title1)} />
        <div className="modalContainer">
          {translateContent(modalContent.desc)}
        </div>
      </Modal>
    </>
  );
};

export default PromoContent;
